import { Component, inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/shared/service/disbursment/client.service';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { PortService } from 'src/app/shared/service/disbursment/port.service';
import { MaCargo } from '../dis-repository/pages/create-cargo/cargo.model';
import { MaVessel } from '../dis-repository/pages/create-client/vessel.model';
import { MaPortAgent } from '../dis-repository/pages/create-port-agent/port-agent.model';
import { ConfirmationDialogComponent } from '../dis-repository/pages/create-port-tariff/confirmation-dialog.component';
import { MaCountry } from '../dis-repository/pages/create-port-tariff/country.model';
import { MaPort } from '../dis-repository/pages/create-port-tariff/port.model';
import { MaPurpose } from '../dis-repository/pages/create-purpose/purpose.model';
import {
  convertVesselStayToMinutes,
  Field,
  fields,
  invoiceReferenceValidation,
  PA_Rules,
} from './port-agent-form.model';
import {
  addAdditionalFieldsToFieldsArray,
  AddedFields,
  autoCompleteFilter,
  calculateVesselStay,
  clearVesselDetails,
  displayFn,
  filterServicesOnPurpose,
  formatToLocalISOString,
  getAdditionalPropertiesObjectFromForm,
  getCompanyIdByName,
  getCurrencyFromCountry,
  getOptionValuefortheFields,
  getPurposeName,
  removeAddedFieldsAndControls,
  restrictDecimal,
  validateVesselStay,
} from './pda.model';
import { ToastrService } from 'ngx-toastr';
import { PortAgentFormService } from 'src/app/shared/service/disbursment/port-agent-form.service';
import { PdaService } from 'src/app/shared/service/disbursment/pda.component.service';
import { EmailDialogComponent } from './email-dialog/email-dialog.component';
import { EmailSentNotificationComponent } from './email-sent-notification/email-sent-notification.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-pda',
  templateUrl: './pda.component.html',
  styleUrls: ['./pda.component.scss'],
})
export class PdaComponent {
  private loader = inject(DisbursmentService);
  isLoading$ = this.loader.loading$;
  pdaCreateForm!: FormGroup;
  countryList: MaCountry[] = [];
  portList: any[] = [];
  vesselList: MaVessel[] = [];
  purposeList: MaPurpose[] = [];
  portAgentList: MaPortAgent[] = [];
  cargoList: MaCargo[] = [];
  clientList: MaPortAgent[] = [];
  currencyList: string[] = [];
portMasterList: any[] = [];
  fields = fields
    .map((field: any) => {
      // Vessel mapping
      if (field.name === 'Vessel') {
        return { ...field, value: 'vessel_id' };
      }

      // FDA → PDA mapping
      if (field.value && field.value.includes('fda')) {
        return { ...field, value: field.value.replace(/fda/g, 'pda') };
      }

      // Add custom readonly flag
      if (field.name === 'FromCurrency') {
        return { ...field, pdaReadOnly: true };
      }

      return field;
    })
    // Optional: filter fields with PAForm === true
    .filter((field) => field.createPdaForm === true);

  addedFields: AddedFields[] = [];
  companyList: { company_id: number; company_name: string }[] = [];
  filteredOptions: { [key: string]: any[] } = {};
  displayFn = displayFn;
  validateVesselStay = validateVesselStay;
  restrictDecimal = restrictDecimal;
  getOptionValue = getOptionValuefortheFields;
  disableProceedToPdabutton = false;
  disablesendRequestButton = false;
  serviceList: PA_Rules = new PA_Rules();
  portServiceList: PA_Rules = new PA_Rules();
  companyId: any;
  username: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: ToastrService,
    private portService: PortService,
    private router: Router,
    private portAgentFormService: PortAgentFormService,
    private pdaService: PdaService,
    private clientService: ClientService,
    private requestFormService: RequestFormService,
  ) {
    this.buildPortAgentForm();
  }

  // method to build the port agent form
  buildPortAgentForm() {
    this.pdaCreateForm = this.fb.group({
      country_id: [null],
      client_id: [null],
      portagent_id: [null],
      cargo_id: [null],
      port_id: [null],
      imo_number: [null],
      vessel_id: [null],
      vessel: [null],
      nrt: [null],
      grt: [null],
      rgrt: [null],
      loa: [null],
      beam: [null],
      depth: [null],
      dwt: [null],
      type: [null],
      purpose_id: [null],
      eta: [null, []],
      etd: [null, []],
      vessel_stay: [null],
      pda_roe: [null],
      voyage: [null],
      pda_currency_from: [null],
      pda_currency_to: [null],
      invoice_ref_no: [null],
    });

    invoiceReferenceValidation;
    Object.keys(this.pdaCreateForm.controls).forEach((key) => {
      this.pdaCreateForm.controls[key].valueChanges.subscribe((value) => {
        if (value === '') {
          this.pdaCreateForm.controls[key].setValue(null);
        }
      });
    });
  }

  autoCompleteFilter = autoCompleteFilter;
  getFilteredOptions(field: any): any[] {
    return this.filteredOptions[field.value] || [];
  }

  ngOnInit() {
    this.username = localStorage.getItem('username') ?? '';
    this.companyId = sessionStorage.getItem('companyId');

    this.getAllMasterData();
    this.fields.forEach((field) => {
      if (field.type === 'select') {
        this.autoCompleteFilter(
          field,
          this.pdaCreateForm,
          this.filteredOptions,
        );
      }
    });
  }
  populateClientData() {
    const companyId = Number(this.companyId);

    if (!companyId || !this.clientList?.length) {
      return;
    }

    const client = this.clientList.find(
      (item: any) => Number(item.company_id) === companyId,
    );

    if (client) {
      this.pdaCreateForm.patchValue({
        client_id: client.company_id,
      });

      // Make Client readonly/disabled
      this.pdaCreateForm.get('client_id')?.disable();
      // Load vessels for this client
    const vslpayload = {
      company_id: client.company_id,
      fields: ['assigned_unassigned'],
    };

    this.loader.show();

    this.clientService.VslListFromDb(vslpayload).subscribe({
      next: (response: any) => {
        this.vesselList = response.assigned_vessels || [];
        this.formatFieldData(this.fields);
        this.loader.hide();
      },
      error: (error: any) => {
        this.vesselList = [];
        this.formatFieldData(this.fields);
        this.loader.hide();

        const errMsg =
          error?.error?.error || 'Failed to fetch vessel details';

        this.snackBar.error(errMsg);
      },
    });
    }
  }
  // method to get all master data
  getAllMasterData(): void {
    this.swapFields();
    this.loader.show();
    const params = {
      fields: ['all'],
    };
    this.portAgentFormService.getMasterData(params).subscribe({
      next: (response: any) => {
        this.countryList = response.country;
        this.purposeList = response.purpose;
        this.portAgentList = response.port_agent;
        this.clientList = response.client;
        this.cargoList = response.cargo;
        this.vesselList = response.vessel;
        this.companyList = response.companies;
        this.currencyList = response.currency;
         this.loadAllPorts();
        this.formatFieldData(this.fields);
        if (this.username !== 'Meraki - Operations') {
          this.populateClientData();
        }
        this.loader.hide();
      },
      error: (err: any) => {
        this.loader.hide();
      },
    });
  }
loadAllPorts(): void {
  this.portService.getAllPorts().subscribe({
    next: (response: any[]) => {
      this.portMasterList = response || [];

      // Only active ports
      this.portList = this.portMasterList
        .filter((port) => port.status === 'Y')
        .map((port) => ({
          port_id: port.port_id,
          name: port.name,
          country_id: port.country_id,
          country_name: port.country_name,
          vessel_fields: port.vessel_fields || [],
        }));

      this.filteredOptions['port_id'] = this.portList;

      this.formatFieldData(this.fields);
    },
    error: (error: any) => {
      this.portMasterList = [];
      this.portList = [];
      this.filteredOptions['port_id'] = [];

      const errMsg =
        error?.error?.error || 'Failed to fetch port details';

      this.snackBar.error(errMsg);
    },
  });
}
  // method to swap fields
  swapFields() {
    const imoIndex = this.fields.findIndex(
      (f) => f.name?.trim() === 'IMO Number',
    );
    const vesselIndex = this.fields.findIndex(
      (f) => f.name?.trim() === 'Vessel',
    );

    if (imoIndex !== -1 && vesselIndex !== -1) {
      const temp = this.fields[imoIndex];
      this.fields[imoIndex] = this.fields[vesselIndex];
      this.fields[vesselIndex] = temp;
      this.fields[imoIndex].type = 'select';
      this.fields[vesselIndex].type = 'input';
    }
  }

  // method to calculate the vessel stay on date change
  onDateChange() {
    const eta = this.pdaCreateForm.get('eta')?.value;
    const etd = this.pdaCreateForm.get('etd')?.value;

    const stay = calculateVesselStay(eta, etd);
    if (stay === 'eta greater than etd') {
      this.pdaCreateForm.get('vessel_stay')?.setValue(null);
      this.pdaCreateForm.get('etd')?.setValue(null);
    } else {
      this.pdaCreateForm.get('vessel_stay')?.setValue(stay);
    }
  }

  // method to format the fieldValue for the select field
  // getOptionValue(field: any, opt: any): any {
  //   const matchedFields = this.fields.filter((f) =>
  //     this.addedFields.some(addedField => addedField.fieldName === f.name.trim())
  //   );
  //   if (field.name === 'ToCurrency' || field.name === 'FromCurrency') {
  //     // If the field is 'ToCurrency' or 'FromCurrency', return the entire option object
  //     return opt;
  //   }
  //   // Check if the field is in the matchedFields for additional fields
  //   else if (matchedFields.some((f) => f.name === field.name)) {
  //     console.log("returning ", opt.name)
  //     return opt.name;
  //   }
  //   else {
  //     // For other fields, return the value corresponding to the dynamic field ID
  //     const key = `${field.name.trim().toLowerCase().replace(/\s+/g, '')}_id`;
  //     return opt[key];
  //   }
  // }

  // Validate all the fields based on the proceed to PDA button click
  setValidationForProceedToPda() {
    // clear the validateion
    Object.keys(this.pdaCreateForm.controls).forEach((key) => {
      this.pdaCreateForm.get(key)?.clearValidators();
      this.pdaCreateForm.get(key)?.updateValueAndValidity({ emitEvent: false });
    });

    // apply validation for all the fields
    Object.keys(this.pdaCreateForm.controls).forEach((key) => {
      const field = this.addedFields.find((f) => f.controlName === key);
      if (field && field.is_mandatory === 'N') {
      } else {
        if (key !== 'rgrt') {
          this.pdaCreateForm.get(key)?.setValidators([Validators.required]);
          this.pdaCreateForm.get(key)?.updateValueAndValidity();
        }
      }
    });
  }

  setValidationForSendRequest() {
    Object.keys(this.pdaCreateForm.controls).forEach((key) => {
      if (key === 'client_id' || key == 'portagent_id') {
        const control = this.pdaCreateForm.get(key);
        control?.setValidators([Validators.required]);
        control?.updateValueAndValidity();
      } else {
        this.pdaCreateForm.get(key)?.clearValidators();
        this.pdaCreateForm.get(key)?.updateValueAndValidity();
      }
    });
  }

  // method to proceed to PDA edit page when the  proceed to PDA button is clicked
  proceedToPda() {
    this.setValidationForProceedToPda();
    if (this.pdaCreateForm.valid) {
      this.disableProceedToPdabutton = true;
      const formData = this.pdaCreateForm.value;
      const formatedJson = this.transformJsonData(formData);
      //Save form data to db
      this.loader.show();
      this.pdaService.postPdaData(formatedJson).subscribe({
        next: (response: any) => {
          this.snackBar.success('PDA data saved successfully');
          sessionStorage.setItem(
            'disbursement_seq',
            JSON.stringify(response.disbursement_seq),
          );
          this.router.navigate(['dis-pda-edit']);
          this.loader.hide();
        },
        error: (error: any) => {
          const errMsg = error?.error?.error || 'Failed to save PDA data';
          this.snackBar.error(errMsg);
          this.disableProceedToPdabutton = false;
          this.loader.hide();
          this.loader.hide();
        },
      });
    } else {
      this.pdaCreateForm.markAllAsTouched();
      this.snackBar.error('Please fill all the required fields');
    }
  }

  // method to format the form data to match the expected structure for the API
  transformJsonData(formData: any): any {
    return {
      comp_id: getCompanyIdByName(this.companyList),
      client_id: formData.client_id,
      portagent_id: formData.portagent_id,
      country_id: formData.country_id,
      port_id: formData.port_id,
      vessel_id: formData.vessel_id,
      imo_number: formData.imo_number,
      vessel: {
        vsl_id: formData.vessel_id?.toString() || '',
        name:
          this.vesselList?.find(
            (vessel) => vessel.vessel_id === formData.vessel_id,
          )?.name || null,
        imo_number: formData.imo_number?.toString() || '',
        grt: formData.grt?.toString() || '',
        nrt: formData.nrt?.toString() || '',
        loa: formData.loa?.toString() || '',
        rgrt: formData.rgrt?.toString() || '',
        beam: formData.beam?.toString() || '',
        depth: formData.depth?.toString() || '',
        dwt: formData.dwt?.toString() || '',
        type: formData.type?.toString() || '',
        additional_properties: this.getAdditionalProperties(),
        additional_properties_object: getAdditionalPropertiesObjectFromForm(
          this.addedFields,
          this.pdaCreateForm,
          this.fields,
        ),
      },
      cargo: {
        cargo_id: formData.cargo_id,
        type:
          this.cargoList.find((cargo) => cargo.cargo_id === formData.cargo_id)
            ?.type || null,
      },
      purpose: {
        purpose_id: formData.purpose_id,
        name:
          this.purposeList.find(
            (purpose) => purpose.purpose_id === formData.purpose_id,
          )?.name || null,
      },
      eta: formData.eta ? formatToLocalISOString(formData.eta) : null,
      etd: formData.etd ? formatToLocalISOString(formData.etd) : null,
      vessel_stay: convertVesselStayToMinutes(formData.vessel_stay),
      roe: +formData.pda_roe || null,
      voyage: formData.voyage,
      pda_currency_to: formData.pda_currency_to,
      pda_currency_from: formData.pda_currency_from,
      invoice_ref_no: formData.invoice_ref_no?.trim() || null,
      port_tariff_rule: {
        items: this.serviceList.items,
      },
    };
  }

  // method to get the drop down field value based on the field name
  formatFieldData(fields: any[]) {
    fields.forEach((field: any) => {
      switch (field.name.trim()) {
        case 'Country':
          field.options = this.countryList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port Agent':
          field.options = this.portAgentList.map((agent: any) => ({
            portagent_id: agent.company_id,
            name: agent.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Client':
          field.options = this.clientList.map((client: any) => ({
            client_id: client.company_id,
            name: client.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Cargo':
          field.options = this.cargoList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port':
          field.options = this.portList;
          this.filteredOptions[field.value] = this.portList;
          break;
        case 'Vessel':
          field.options = this.vesselList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Purpose':
          field.options = this.purposeList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'FromCurrency':
        case 'ToCurrency':
          field.options = this.currencyList;
          this.filteredOptions[field.value] = field.options;
          break;
        default:
      }
    });
  }

  // method to open the email dialog when the  send request button is clicked
  openEmailDialog() {
    this.setValidationForSendRequest();
    this.pdaCreateForm.markAllAsTouched();
    if (this.pdaCreateForm.valid) {
      const portAgent = this.portAgentList.filter((agent) => {
        return (
          agent.company_id === this.pdaCreateForm.get('portagent_id')?.value
        );
      });
      const clientEmail = this.clientList.filter((client) => {
        return client.company_id === this.pdaCreateForm.get('client_id')?.value;
      });
      const dialogRef = this.dialog.open(EmailDialogComponent, {
        disableClose: true,
        panelClass: 'email-dialog-style',
        width: '800px',
        height: '500px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        data: {
          to: portAgent[0]?.email || '',
          cc: clientEmail[0]?.email || '',
        },
      });
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.loader.show();
          const formData = this.pdaCreateForm.value;
          const formatedJson = this.transformJsonData(formData);
          formatedJson.email_to = data.to;
          formatedJson.email_cc = data.cc;
          formatedJson.email_signature = data.email_signature;
          formatedJson.update_signature = data.update_signature;
          ((formatedJson.comp_id = getCompanyIdByName(this.companyList)),
            (this.disablesendRequestButton = true));
          this.pdaService.pdaCreateByPortAgent(formatedJson).subscribe({
            next: (response: any) => {
              this.loader.hide();
              const dialogRef = this.dialog.open(
                EmailSentNotificationComponent,
                {
                  disableClose: true,
                  panelClass: 'email-dialog-style',
                  width: '400px',
                  height: '150px',
                  data: {
                    email: data.to,
                  },
                },
              );
              dialogRef.afterClosed().subscribe((data) => {
                if (data) {
                  this.router.navigate(['/dis-disbursment']);
                }
              });
            },
            error: (err: any) => {
              this.disablesendRequestButton = false;
              this.loader.hide();
              const errMsg = err?.error?.error || 'Failed to send PDA data';
              this.snackBar.error(errMsg);
            },
          });
        }
      });
    }
  }

  // method to get ports by country
  onSelect(fieldName: string, event: any) {
    if (fieldName === 'Country') {
      const currency = getCurrencyFromCountry(this.countryList, event.value);
      this.pdaCreateForm.patchValue({
        pda_currency_from: currency,
      });
      this.loader.show();
      this.portService.getPortsByCountryId(event.value).subscribe({
        next: (ports) => {
          this.portList = ports;
          this.filteredOptions['port_id'] = ports;
          this.formatFieldData(this.fields);
          this.loader.hide();
        },
        error: (error: any) => {
          this.portList = [];
          this.loader.hide();
          const errMsg = error?.error?.error;
          this.snackBar.error(errMsg);
        },
      });
    } else if (fieldName === 'Vessel') {
      const control = this.pdaCreateForm.get('vessel_id');
      const value = control?.value;
      const selectedVessel = this.vesselList.filter(
        (vessel) => vessel.vessel_id === value,
      );
      if (selectedVessel.length > 0) {
        const vessel = selectedVessel[0];
        this.pdaCreateForm.patchValue({
          imo_number: vessel.imo_number,
          nrt: vessel.nrt,
          grt: vessel.grt,
          rgrt: vessel.rgrt,
          depth: vessel.depth,
          loa: vessel.loa,
          beam: vessel.beam,
          type: vessel.type,
          dwt: vessel.dwt,
          vessel_id: vessel.vessel_id,
          vessel: vessel.name,
        });
        control?.setErrors(null);
      }
    } else if (fieldName === 'Client') {
      this.loader.show();
      const vslpayload = {
        company_id: this.pdaCreateForm.get('client_id')?.value,
        fields: ['assigned_unassigned'],
      };
      this.clientService.VslListFromDb(vslpayload).subscribe({
        next: (response: any) => {
          this.vesselList = response.assigned_vessels || [];
          this.formatFieldData(this.fields);
          this.loader.hide();
        },
        error: (error: any) => {
          this.vesselList = [];
          const errMsg =
            error?.error?.error || 'Failed to fetch vessel details';
          this.snackBar.error(errMsg);
          this.loader.hide();
        },
      });
    } else if (fieldName === 'Port') {
      const port_id = this.pdaCreateForm.get('port_id')?.value;
      // Clear existing additional fields completely
      removeAddedFieldsAndControls(
        this.pdaCreateForm,
        this.addedFields,
        this.fields,
      );
      this.addedFields = [];
      // Add new fields for the selected port
      this.addedFields = addAdditionalFieldsToFieldsArray(
        port_id,
        this.portList,
        this.fields,
        this.pdaCreateForm,
        this.addedFields,
        this.filteredOptions,
        this.fb,
      );
      this.tariffrulesByPort(port_id);
    } else if (fieldName === 'Purpose') {
      const purpose_id = this.pdaCreateForm.get('purpose_id')?.value;
      const purpose = getPurposeName(this.purposeList, purpose_id);
      this.serviceList.items = filterServicesOnPurpose(
        purpose,
        this.portServiceList.items,
      );
    } else if (fieldName === 'Port') {

    const portId = this.pdaCreateForm.get('port_id')?.value;

    const selectedPort = this.portMasterList.find(
      (port) => Number(port.port_id) === Number(portId)
    );

    if (!selectedPort) {
      return;
    }

    // -----------------------------------
    // 1. Populate Country
    // -----------------------------------

    const countryId = selectedPort.country_id;

    this.pdaCreateForm.patchValue(
      {
        country_id: countryId,
      },
      { emitEvent: false }
    );

    // -----------------------------------
    // 2. Populate Currency
    // -----------------------------------

    const currency = getCurrencyFromCountry(
      this.countryList,
      countryId
    );

    this.pdaCreateForm.patchValue(
      {
        pda_currency_from: currency,
      },
      { emitEvent: false }
    );

    // -----------------------------------
    // 3. Remove previous dynamic fields
    // -----------------------------------

    removeAddedFieldsAndControls(
      this.pdaCreateForm,
      this.addedFields,
      this.fields
    );

    this.addedFields = [];

    // -----------------------------------
    // 4. Add fields for selected port
    // -----------------------------------

    this.addedFields = addAdditionalFieldsToFieldsArray(
      portId,
      this.portList,
      this.fields,
      this.pdaCreateForm,
      this.addedFields,
      this.filteredOptions,
      this.fb
    );

    // -----------------------------------
    // 5. Load tariff rules
    // -----------------------------------

    this.tariffrulesByPort(portId);

  }
  }

  // method to clear the data on click of clear all button
  clearData() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: 'Clear Data',
        text: `Are You Sure, You want to clear the form?                                                                                                                    
        All entered information will be lost`,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pdaCreateForm.reset();

        // Clear all validators to remove error states
        Object.keys(this.pdaCreateForm.controls).forEach((key) => {
          this.pdaCreateForm.get(key)?.clearValidators();
          this.pdaCreateForm.get(key)?.updateValueAndValidity();
        });
      }
    });
  }

  // set the additional properties field
  getAdditionalProperties(): { [key: string]: any } {
    const additionalProps: { [key: string]: any } = {};
    const dateFields = this.fields
      .filter((field) => field.type === 'date')
      .map((field) => field.name);
    this.addedFields.forEach(({ fieldName, controlName }) => {
      let value = this.pdaCreateForm.get(controlName)?.value ?? null;
      additionalProps[fieldName] = value;
      if (dateFields.includes(fieldName) && value) {
        additionalProps[fieldName] = formatToLocalISOString(value);
      }
    });
    return additionalProps;
  }

  onRemove(field: Field): void {
    if (
      field?.name === 'Country' &&
      !this.pdaCreateForm.get('country_id')?.value
    ) {
      this.pdaCreateForm.get('port_id')?.setValue(null);
      this.portList = [];
      this.filteredOptions['port_id'] = [];
    } else if (
      field?.name === 'Client' &&
      !this.pdaCreateForm.get('client_id')?.value
    ) {
      this.pdaCreateForm.get('vessel_id')?.setValue(null);
      this.vesselList = [];
      this.filteredOptions['vessel_id'] = [];
      clearVesselDetails(this.pdaCreateForm);
    } else if (
      field?.name === 'Vessel' &&
      !this.pdaCreateForm.get('vessel_id')?.value
    ) {
      this.pdaCreateForm.get('vessel_id')?.setValue(null);
      clearVesselDetails(this.pdaCreateForm);
    }
  }

  tariffrulesByPort(port_id: number) {
    this.serviceList = new PA_Rules();
    const requestBody = {
      page: 1,
      page_size: 1,
      query_name: '',
      port_id: port_id,
    };
    this.loader.show();
    this.portService.getTariffRules(requestBody).subscribe({
      next: (res) => {
        this.portServiceList = res?.data[0]?.rules;
        const purposeId = this.pdaCreateForm.get('purpose_id')?.value;
        const purpose = getPurposeName(this.purposeList, purposeId);
        this.serviceList.items = filterServicesOnPurpose(
          purpose,
          this.portServiceList.items,
        );
        this.loader.hide();
      },
      error: (err) => {
        this.loader.hide();
        const errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(errMsg);
      },
    });
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
